var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-container-spesa v-overflow editUtente editSpesa",staticStyle:{"padding-top":"84px","background-color":"rgb(255 255 255 / 50%)"}})}
var staticRenderFns = []

export { render, staticRenderFns }